import { render, staticRenderFns } from "./detailDialog.vue?vue&type=template&id=19fa9b2b&scoped=true"
import script from "./detailDialog.vue?vue&type=script&lang=js"
export * from "./detailDialog.vue?vue&type=script&lang=js"
import style0 from "./detailDialog.vue?vue&type=style&index=0&id=19fa9b2b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19fa9b2b",
  null
  
)

export default component.exports